import React, { useState, useCallback } from 'react';
import { WithPermission } from './Toolbar.jsx';
import { FaIcon } from '../common/Icons.jsx';
import { DATA_TYPE_PROP_MAP } from '../common/AgGrid/index.jsx';

const CheckBox = ({checked}) =>
  <div
    style={{marginRight: 'var(--ag-widget-horizontal-spacing)'}}
    className={`ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper ${checked ? 'ag-checked' : ''}`}
    role='presentation'
  >
    <input className='ag-input-field-input ag-checkbox-input' type='checkbox' tabIndex='-1'/>
  </div>;

const columnDefsWithValidations = (existingColumns, item, checked) => {
  const newDefs = checked ?
    [...existingColumns.filter(c => !c?.validationId?.startsWith(`validation-item-${item.id}`))] :
    [...existingColumns,
      {
        validationId: `validation-item-${item.id}`,
        headerName: item.name,
        field: item.accessor,
        filter: DATA_TYPE_PROP_MAP[item.column_type]?.filter,
        filterParams: {
          ...DATA_TYPE_PROP_MAP[item.column_type]?.filterParams,
          cellRenderer: 'dgValidationCell'
        },
        resizable: true,
        cellRenderer: 'dgValidationCell',
        sortable: true,
        pinned: 'right'
      }
    ];
  return newDefs
};

const columnDefsWithoutValidations = (existingColumns) => {
  return existingColumns.filter(c => !c?.validationId?.startsWith(`validation-item-`))
};

const Validations = ({api, context, items, presets}) => {
  const [selectedItems, setSelectedItems] = useState({});

  const onCheck = (item, checked) => {
    const preset = presets.find(v => v.id == item.preset_id);

    // User can only have multiple validations selected if they are linked to same preset
    if (!items.filter(v => selectedItems[v.id] && v.preset_id != preset.id).length > 0) {
      const newItems = Object.entries({...selectedItems, [item.id]: !checked}).reduce((a,[k,v]) => (v ? (a[k]=v, a) : a), {});

      if (_.isEmpty(newItems)) {
        resetState();
      } else {
        setSelectedItems(newItems);
        restorePreset(checked, preset, item, newItems);
      }
    }
  };

  const restorePreset = useCallback((checked, preset, item, newItems) => {
    api.applyColumnState({state: preset.column_state, applyOrder: true});
    api.setFilterModel(preset.filter_model);
    api.setGridOption('context', {...context, get_rows_params: {...(context.get_rows_params || {}), validation_ids: Object.keys(newItems)}});
    api.setGridOption('columnDefs', columnDefsWithValidations(api.getColumnDefs(), item, checked));
    api.setGridOption('pivotMode', preset.column_state.some(a => a.pivot));
    api.refreshServerSide();
  });

  const resetState = useCallback(() => {
    setSelectedItems([]);
    api.resetColumnState();
    api.setFilterModel([]);
    api.setGridOption('context', {...context, get_rows_params: {...(context.get_rows_params || {}), rowGroupCols: [], validation_ids: []}});
    api.setGridOption('columnDefs', columnDefsWithoutValidations(api.getColumnDefs()));
    api.setGridOption('pivotMode', false);
    api.refreshServerSide();
  });

  return <div className='dg-toolpanel'>
    <div className='dg-separated'>
      <div className='dg-header dg-link-hover d-flex align-items-center' onClick={resetState}>
        <FaIcon type='refresh'/><span>{I18n.t('reset')}</span>
      </div>
    </div>

    <div className='dg-separated'>
      <div className='dg-header d-flex' style={{justifyContent: 'space-between'}}>
        <b>{I18n.t('validations')}</b>
      </div>
      {items.map(item =>
        <div
          className='dg-link-hover dg-list-item text-truncate d-flex'
          style={{justifyContent: 'space-between'}}
          title={item.name}
          onClick={() => onCheck(item, selectedItems[item.id] != undefined)}
          key={'validation-item-' + item.id}
        >
          <div className='d-flex'>
            <CheckBox checked={selectedItems[item.id]}/>
            <span className='text-truncate'>{item.name}</span>
          </div>
        </div>
      )}
    </div>
  </div>
};

export default function ValidationsPanel({api, context, datagrid}) {
  return <WithPermission permissions={context.permissions} permission='validations_view'>
    <Validations {...{api, context, items: datagrid?.validations || [], presets: datagrid?.presets || []}} />
  </WithPermission>
};
